export const EXTERNAL_LINKS = {
  PRIVACY_POLICY: "https://geolysisllc.com/excel/legal/privacy-policy",
  TERMS_OF_USE: "https://geolysisllc.com/excel/legal/terms-of-use",
};
